import { Form, Input, Radio, Tooltip } from 'antd';
import StructureTypeList from '../../utils/StructureTypeList';
import { InfoCircleFilled } from '@ant-design/icons';
import AccionaButton from '../../../../../../../components/AccionaButton';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const BatchForm = ({ handleCustomSearch }) => {
  const [batchCodeForm] = Form.useForm();
  const [radioValue, setRadioValue] = useState();
  const intl = useIntl();
  return (
    <Form
      style={{ padding: '10px', width: '150px' }}
      onFinish={() => {
        batchCodeForm.validateFields().then((values) => {
          if (
            values.searchType === 'noBatch' ||
            (values.searchType === 'batch' && values.batchNumber)
          ) {
            handleCustomSearch(
              {
                'concrete_batch_data.batch_code': values.batchNumber || 'null',
              },
              'concrete_batch',
            );
          }

          if (!values.searchType) {
            handleCustomSearch(
              { 'concrete_batch_data.batch_code': undefined },
              'concrete_batch',
            );
          }
        });
      }}
      form={batchCodeForm}
    >
      <Form.Item name="searchType" style={{ marginBottom: '5px' }}>
        <Radio.Group
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '10px',
          }}
          onChange={({ target }) => {
            setRadioValue(target.value);
          }}
        >
          <Radio
            value="noBatch"
            onClick={() => {
              batchCodeForm.resetFields(['batchNumber']);
            }}
          >
            {intl.formatMessage({
              id: 'pages.quality.normative.traceability.list.batchForm.noBatch',
            })}
          </Radio>
          <Radio value="batch">
            {' '}
            {intl.formatMessage({
              id: 'pages.quality.normative.traceability.list.batchForm.batch',
            })}{' '}
          </Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="batchNumber">
        <Input disabled={radioValue !== 'batch'}></Input>
      </Form.Item>
      <AccionaButton
        msg={intl.formatMessage({ id: 'search' })}
        classIcon="icon fas fa-search"
        style={{
          margin: '8px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '85%',
          flex: 0,
        }}
        className="btn btn-red"
        onClick={() => {
          batchCodeForm.submit();
        }}
      />
      <AccionaButton
        msg={intl.formatMessage({ id: 'uncheck' })}
        classIcon="icon fas fa-window-close"
        style={{
          margin: '8px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          width: '85%',
          flex: 0,
        }}
        className="btn btn-red"
        onClick={() => {
          setRadioValue(undefined);
          batchCodeForm.resetFields();
          batchCodeForm.submit();
        }}
      />
    </Form>
  );
};

BatchForm.propTypes = {
  handleCustomSearch: PropTypes.func.isRequired,
};

export const COLUMNS_HEADERS = ({ structuralElements, normative }) => {
  return {
    docket_number: {
      align: 'left',
      width: '120px',
      sortable: true,
      searchable: true,
    },
    arriving_date: { align: 'center', sortable: true, ascSort: true },
    recipe: { align: 'center', sortable: true },
    structural_element: {
      width: '150px',
      align: 'center',
      sortable: true,
      filterable: true,
      filterableData:
        structuralElements?.reduce((acc, cur) => {
          acc[cur.id] = `${cur.structural_element}`;
          return acc;
        }, {}) || {},
      extra:
        normative === 'coe' ? (
          <Tooltip
            title={<StructureTypeList />}
            overlayInnerStyle={{ width: '40vw', padding: '2em 1em' }}
          >
            <InfoCircleFilled />
          </Tooltip>
        ) : null,
    },
    control_type: { align: 'center', sortable: true },
    concrete_batch: {
      align: 'center',
      sortable: true,
      //searchable: true,
      width: '100px',
      customSearchDropdown: ({ handleCustomSearch }) => (
        <BatchForm handleCustomSearch={handleCustomSearch} />
      ),
    },
  };
};
